import handleWalletAction from './handlers/handleWalletAction'
import { setLockInterval, subscribeToWalletState } from './handlers/handleWalletState'
import { handleWalletSwitch } from './handlers/handleWalletSwitch'
import handleBackgroundMessage from './handlers/handleBackgroundMessages'
import { syncStores } from '@core/state/index.web'
import { initializeMessenger } from '@plug-core/messengers'

export const initializeWalletHandlers = () => {
  // Initialize state synchronization
  syncStores()
  
  // Create messengers for different connections
  // In web, they all point to the same instance
  const popupMessenger = initializeMessenger({ connect: 'popup' })
  const inpageMessenger = initializeMessenger({ connect: 'inpage' })
  const backgroundMessenger = initializeMessenger({ connect: 'background' })
  
  // Initialize core wallet handlers
  // This sets up the reply handler for 'plug_wallet_action'
  handleWalletAction()
  
  // Handle background messages for session management
  handleBackgroundMessage({ 
    inpageMessenger, 
    popupMessenger 
  })
  
  // Handle wallet switching notifications
  handleWalletSwitch({ inpageMessenger })
  
  // Subscribe to wallet state changes and set up auto-lock
  subscribeToWalletState([popupMessenger, inpageMessenger])
  setLockInterval()
  
  console.log('Web wallet handlers initialized')
}

// Export individual handlers for direct use if needed
export { default as handleWalletAction } from './handlers/handleWalletAction'
export { setLockInterval, subscribeToWalletState } from './handlers/handleWalletState'